import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { MemberSearch } from './member-search.model';
import { FormatService } from '../services/format.service';
import { MemberSearchFilter } from './member-search-filter.model';
import { MemberData } from './member-data.model';
import { TenantService } from 'src/app/tenant/tenant.service';
import { Extension } from '../profile/profile/profile.model';
import { FormArray } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class MemberSearchService {
  apiHost: string = environment.apiHost;
  public memberArr: MemberSearch[] = [];
  public selectedMembers: number[] = [];
  public selectedAccounts: string[] = [];
  public assignMembers: number[] = [];
  public searchResult: any = null;
  public allData: MemberData[] = [];
  public filter: MemberSearchFilter = new MemberSearchFilter();
  public age: string;
  public grade: string;
  public city: string;
  public state: string;
  public zip: string;
  public userId: string;
  public subdomain: string = '';
  public keepSelected = false;
  public lastClickedMember: boolean = false;
  constructor(
    private http: HttpClient,
    private _format: FormatService,
    private tenantService: TenantService
  ) { }

  maskdata(val: string): string {
    if (this.subdomain == 'demo') return val[0].toUpperCase() + 'XXXXXXXXX';
    return val;
  }

  initializeFilter(): MemberSearchFilter {
    return {
      firstName: '',
      lastName: '',
      diocese: 0,
      department: 0,
      superGroup: 0,
      group: 0,
      email: '',
      phone: '',
      gender: null,
      maritalStatus: null,
      occupation: null,
      account: null,
      role: null,
      age: [],
      grade: [],
      city: [],
      state: [],
      zip: [],
      membership: null,
      picture: null,
      category: null,
      service: null,
      attendanceStartDate: null,
      attendanceEndDate: null,
      attendanceDateRange: null,
      followupDateRange: null,
      donationDateRange: null,
      frequency: 0, 
      frequencyType: null,
      donationStartDate: null,
      donationEndDate: null,
      singleDonationMode: false,
      donationStartRange: 0,
      donationEndRange: 0,
      result: 1,
      leaders: false, 
      has_role: null, 
      note_selection: null,
      birthdayMonth: 0,
      birthdayDay: 0, 
      attendanceStatus: 2,
      outReachStatus: null,
      outReachTask: null,
      outReachStartDate: null,
      outReachEndDate: null,
      outReachAssignee: null,
      includeAccounts: 1, 
      massText: false,
      tag: 0, 
      notification: 0,
      extensionValues: []
    };
  } 

  ToggleSelection(user: any) {
    user.selected = !user.selected;
    if (user.memberId > 0) {
      var foundIndex = this.selectedMembers.indexOf(user.memberId);
      if (foundIndex >= 0) this.selectedMembers.splice(foundIndex, 1);
      else this.selectedMembers.push(user.memberId);
    }
    else // it's an accountId
    {
      var foundIndex = this.selectedAccounts.indexOf(user.id);
      if (foundIndex >=0) this.selectedAccounts.splice(foundIndex, 1);
      else this.selectedAccounts.push(user.id);
    }
  }

  AddSelection(user: any) {
    user.selected = true;
    if (user.memberId > 0)
    {
      var foundIndex = this.selectedMembers.indexOf(user.memberId);
      if (foundIndex == -1) this.selectedMembers.push(user.memberId);
    }
    else
    {
      var foundIndex = this.selectedAccounts.indexOf(user.id);
      if (foundIndex == -1) this.selectedAccounts.push(user.id);
    }
  }

  RemoveSelection(user: any) {
    user.selected = false;
    if (user.memberId > 0)
    {
      var foundIndex = this.selectedMembers.indexOf(user.memberId);
      if (foundIndex >= 0) this.selectedMembers.splice(foundIndex, 1);
    }
    else
    {
      var foundIndex = this.selectedAccounts.indexOf(user.id);
      if (foundIndex >= 0) this.selectedAccounts.splice(foundIndex, 1);
    }
  }

  RefreshSelection() {
    this.memberArr.map((a) =>
    {
      a.memberId > 0 && this.selectedMembers.indexOf(a.memberId) >= 0
        ? (a['selected'] = true)
        : (a['selected'] = false)
      if (a['selected'] == false)  
        a.memberId == 0 && this.selectedAccounts.indexOf(a.id) >= 0
        ? (a['selected'] = true)
        : (a['selected'] = false)        
    }
    );
  }

  getByPhoneNumber(phoneNumber: string): Promise<string> {
    var link = `${this.apiHost}/Member/GetAccountHolderUserByPhone?PhoneNumber=`;
    let promise = new Promise<string>((resolve, reject) => {
      let apiURL = link + phoneNumber;
      this.http
        .get<string>(apiURL)
        .toPromise()
        .then(
          (res) => {
            this.userId = res;
            resolve(this.userId);
          },
          (msg) => {
            this.memberArr = [];
            resolve('');
          }
        );
    });
    return promise;
  }

  ResetAll() {
    this.memberArr.map((a) => (a['selected'] = false));
    this.selectedMembers = [];
    this.selectedAccounts = [];
  }
  //test git

  async SelectAll(
    filter: MemberSearchFilter,
    filterPage: string,
    sortByFirst: boolean
  ): Promise<MemberSearch[]> {
    var link =
      `${this.apiHost}/Member/AdvancedSearch?` + filterPage + '&SortByFirst=' + sortByFirst + '&IdOnly=' + true;
    this.subdomain = this.tenantService.getTenant();
    let promise = new Promise<MemberSearch[]>(async (resolve, reject) => {
       await this.http
        .post<MemberSearch[]>(link, filter)
        .toPromise()
        .then(
          (res) => {
            if (this.keepSelected == false) {
              this.selectedMembers =
                res == null ? [] : res['data'].filter(x => x.memberId > 0).map((a) => a.memberId);
              this.selectedAccounts = 
                res == null ? [] : res['data'].filter(x => x.memberId == 0).map((a) => a.userId);
              this.memberArr.forEach((a) => (a['selected'] = true));
            } else { 
              this.selectedMembers =
                res == null
                  ? this.selectedMembers
                  : this.selectedMembers.concat(
                    res['data'].filter(x => x.memberId > 0).map((a) => a.memberId) 
                  );
              this.selectedAccounts =
              res == null
              ? this.selectedAccounts
              : this.selectedAccounts.concat(
                res['data'].filter(x => x.memberId == 0).map((a) => a.userId)
              );
          this.memberArr.forEach((a) => (a['selected'] = true));
            }
            this.selectedMembers = [...new Set(this.selectedMembers)];
            this.selectedAccounts = [...new Set(this.selectedAccounts)];
            this.RefreshSelection();
            resolve(res);
          },
          (msg) => {
            resolve(null);
          }
        );
    });
    return promise;
  }

  SelectAllAttendance(
    filter: MemberSearchFilter,
    filterPage: string,
    sortByFirst: boolean
  ): Promise<MemberSearch[]> {
    var link =
      `${this.apiHost}/Member/AdvancedSearch?` + filterPage + '&SortByFirst=' + sortByFirst + '&AttendanceOnly=' + true;
    this.subdomain = this.tenantService.getTenant();
    let promise = new Promise<MemberSearch[]>((resolve, reject) => {
      this.http
        .post<MemberSearch[]>(link, filter)
        .toPromise()
        .then(
          (res) => {
            this.memberArr = res == null ? [] : res['data'];
            resolve(res);
          },
          (msg) => {
            this.memberArr = [];
            resolve(null);
          }
        );
    });
    return promise;
  }

  AdvancedSearch(
    filter: MemberSearchFilter,
    filterPage: string,
    sortByFirst: boolean
  ): Promise<MemberSearch[]> {
    let recency = false;
    if (sortByFirst == null) 
    {
      sortByFirst = true;
      recency = true;
    }
    var link = `${this.apiHost}/Member/AdvancedSearch?` + filterPage + '&SortByFirst=' + sortByFirst + '&Recency=' + recency;
    this.subdomain = this.tenantService.getTenant();
    let promise = new Promise<MemberSearch[]>((resolve, reject) => {
      this.http
        .post<MemberSearch[]>(link, filter)
        .toPromise()
        .then(
          (res) => {
            this.memberArr = res == null ? [] : res['data'];
            if (res['data'].length > 0) this.handleSimilarNames();
            else this.memberArr = [];
            res['data'] = this.memberArr;
            this.RefreshSelection();
            resolve(res);
          },
          (msg) => {
            reject(msg);
          }
        );
    });
    return promise;
  }

  ScopedAdvancedSearch(
    EventId: number,
    filter: MemberSearchFilter,
    filterPage: string
  ): Promise<MemberSearch[]> {
    var link = `${this.apiHost}/Member/ScopedAdvancedSearch?` + filterPage;
    this.subdomain = this.tenantService.getTenant();
    let promise = new Promise<MemberSearch[]>((resolve, reject) => {
      this.http
        .post<MemberSearch[]>(link + '&EventId=' + EventId.toString(), filter)
        .toPromise()
        .then(
          (res) => {
            this.memberArr = res == null ? [] : res['data'];
            if (res['data'].length > 0) this.handleSimilarNames();
            else this.memberArr = [];
            res['data'] = this.memberArr;
            if (this.keepSelected == false)
            {
               this.selectedMembers = [];
               this.selectedAccounts = [];
            }
            this.RefreshSelection();
            resolve(res);
          },
          (msg) => {
            reject(msg);
          }
        );
    });
    return promise;
  }

  GetAllData(): Promise<MemberData[]> {
    var link = `${this.apiHost}/Member/GetAllData`;
    this.subdomain = this.tenantService.getTenant();
    let promise = new Promise<MemberData[]>((resolve, reject) => {
      this.http
        .post<MemberData[]>(link, this.memberArr)
        .toPromise()
        .then(
          (res) => {
            this.allData = res;
            if (this.allData != null)
              this.allData = this.allData.sort((a, b) => {
                if (
                  a.firstName + ' ' + a.lastName <
                  b.firstName + ' ' + b.lastName
                )
                  return -1;
                if (
                  a.firstName + ' ' + a.lastName >
                  b.firstName + ' ' + b.lastName
                )
                  return 1;
                return 0;
              });
            resolve(this.allData);
          },
          (msg) => {
            this.memberArr = [];
            resolve([]);
          }
        );
    });
    return promise;
  }

  async GetSelectedDataToDownload(): Promise<MemberData[]> {
    var link = `${this.apiHost}/Member/GetDataByMemberIds`;
    let promise = new Promise<MemberData[]>((resolve, reject) => {
      this.http
        .post<MemberData[]>(link, this.selectedMembers)
        .toPromise()
        .then(
          (res) => {
            this.allData = res;
            if (this.allData != null)
              this.allData = this.allData.sort((a, b) => {
                if (
                  a.firstName + ' ' + a.lastName <
                  b.firstName + ' ' + b.lastName
                )
                  return -1;
                if (
                  a.firstName + ' ' + a.lastName >
                  b.firstName + ' ' + b.lastName
                )
                  return 1;
                return 0;
              });
            resolve(this.allData);
          },
          (msg) => {
            this.memberArr = [];
            resolve([]);
          }
        );
    });
    return promise;
  }

  async GetSelectedAttendanceToDownload(): Promise<MemberData[]> {
    var link = `${this.apiHost}/Member/GetAttendanceDataByMemberIds`;
    let promise = new Promise<MemberData[]>((resolve, reject) => {
      this.http
        .post<MemberData[]>(link, this.selectedMembers)
        .toPromise()
        .then(
          (res) => {
            this.allData = res;
            if (this.allData != null)
              this.allData = this.allData.sort((a, b) => {
                if (
                  a.firstName + ' ' + a.lastName <
                  b.firstName + ' ' + b.lastName
                )
                  return -1;
                if (
                  a.firstName + ' ' + a.lastName >
                  b.firstName + ' ' + b.lastName
                )
                  return 1;
                return 0;
              });
            resolve(this.allData);
          },
          (msg) => {
            this.memberArr = [];
            resolve([]);
          }
        ); 
    });
    return promise;
  }

  getAllByName(
    firstName: string,
    lastName: string,
    DataScope: string,
    AccountHolder: string
  ): Promise<MemberSearch[]> {
    if (firstName == null) firstName = '';
    if (lastName == null) lastName = '';
    this.subdomain = this.tenantService.getTenant();
    var link = `${this.apiHost}/Member/GetAllChurchPeople?FirstName=`;
    if (DataScope == 'Members' && AccountHolder == 'true')
      link = `${this.apiHost}/Member/GetMemberAccountHolders?FirstName=`;
    if (DataScope == 'Universe' && AccountHolder == 'false')
      link = `${this.apiHost}/Member/GetAllNames?FirstName=`;
    let promise = new Promise<MemberSearch[]>((resolve, reject) => {
      let apiURL = link + firstName + '&LastName=' + lastName;
      this.http
        .get<MemberSearch[]>(apiURL)
        .toPromise()
        .then(
          (res) => {
            this.memberArr = res;
            if (this.memberArr != null)
              this.memberArr = this.memberArr.sort((a, b) => {
                if (
                  a.firstName + ' ' + a.lastName <
                  b.firstName + ' ' + b.lastName
                )
                  return -1;
                if (
                  a.firstName + ' ' + a.lastName >
                  b.firstName + ' ' + b.lastName
                )
                  return 1;
                return 0;
              });
            if (res != null) this.handleSimilarNames();
            resolve(this.memberArr);
          },
          (msg) => {
            this.memberArr = [];
            resolve(this.memberArr);
          }
        );
    });
    return promise;
  }

  StoreInfo(element: MemberSearch, isDateOfBirth: boolean): MemberSearch {
    element['fullName'] = (
      element.firstName +
      ' ' +
      this.maskdata(element.lastName)
    ).trim();

    if (isDateOfBirth == true)
      element['fullName'] =
        element['fullName'] +
        ' (' +
        this._format.GetDBOFormat(element.dateOfBirth) +
        ')';
    element.id = element['userId'];
    return element;
  }

  handleSimilarNames() {
    var prevName: string =
      this.memberArr[0].firstName +
      ' ' +
      this.maskdata(this.memberArr[0].lastName);
    this.memberArr[0] = this.StoreInfo(this.memberArr[0], false);
    var backWasHandled: boolean = false;
    this.memberArr[0]['selected'] = false;
    for (let i = 1; i < this.memberArr.length; i++) {
      this.memberArr[i]['selected'] = false;
      if (
        prevName.toUpperCase() ==
        this.memberArr[i].firstName.trim() +
        ' ' +
        this.maskdata(this.memberArr[i].lastName.trim().toUpperCase())
      ) {
        if (backWasHandled == false) {
          this.memberArr[i - 1]['fullName'] =
            this.memberArr[i - 1]['fullName'] +
            ' (' +
            this._format.GetDBOFormat(this.memberArr[i - 1].dateOfBirth) +
            ')';
        }

        this.memberArr[i] = this.StoreInfo(this.memberArr[i], true);
        backWasHandled = true;
      } else {
        prevName =
          this.memberArr[i].firstName + ' ' + this.memberArr[i].lastName;
        backWasHandled = false;
        this.memberArr[i] = this.StoreInfo(this.memberArr[i], false);
      }
    }
  }
}
